import { Swiper, SwiperSlide } from 'swiper/react';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Image from '@/components/UI/Image';

const StoryNewCommunity = () => {
    const { useState, isMobile, useLang } = useGlobal();
    const { t } = useLang('brandstory');
    const imgList = ['/img/stories/common/csr/csr1.jpg', '/img/stories/common/csr/csr2.jpg', '/img/stories/common/csr/csr3.jpg'];
    return (
        <div id="storyCommunity" className={`${isMobile ? styled.story_mobile_community : styled.story_community} ${isMobile ? '' : 'content'}`}>
            <div className="header">
                <h5 className="screen-title">{t('menu.newcommunity')}</h5>
                <h5 className="screen-desc">{t('newcommunity.title')}</h5>
            </div>
            <p className="desc">{t('newcommunity.desc')}</p>
            {isMobile ? (
                <Swiper
                    loop
                    id="birds_swiper"
                    className="swiper_controller"
                    pagination={{ clickable: true }}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    effect="cards"
                >
                    {imgList.map((item, index) => (
                        <SwiperSlide className="imgitem" key={index}>
                            <Image src={item} layout="fill" className="fullImgs" alt={t('newcommunity.title')} aria-label={t('newcommunity.title')} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                <div className="imglist">
                    {imgList.map((item, index) => (
                        <div className="imgitem" key={index}>
                            <Image src={item} layout="fill" className="fullImgs" alt={t('newcommunity.title')} aria-label={t('newcommunity.title')} />
                        </div>
                    ))}
                </div>
            )}

            {/* <p className="more">{t('newcommunity.more')}</p> */}
        </div>
    );
};

export default StoryNewCommunity;
